import { Inject, Optional } from '@angular/core';

import { LANGUAGE_CODE, TranslationsMap } from '../interfaces/TranslationsMap';

export abstract class BaseTranslationPipe {

    protected translations: TranslationsMap;

    constructor(@Optional() @Inject(LANGUAGE_CODE) protected language: (keyof TranslationsMap)) {
    }

    transform(value: string): any {
        if (!this.translations[this.language]) {
            console.warn(`Translation file for '${this.language}' does not exist.`);
            return value;
        }

        return this.translations[this.language][value] || value;
    }
}
